import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { MessengerService } from '@services/messenger/messenger.service';

@Directive({
    selector: '[ifPrivilege]',
    standalone: false
})
export class IfPrivilegeDirective {

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private ms: MessengerService) {
  }

  @Input() set ifPrivilege(data: { name: string, value: string }) {

    const privileges = this.ms.$activePrivileges.getValue();

    if (!privileges) {
      this.viewContainer.clear();
      return;
    }

    for (const privilege of privileges) {
      if (privilege.privilegeName === data.name && privilege.value === data.value) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        return;
      }
    }

    this.viewContainer.clear();
    return;
  }
}
